import React from "react";
import { Header } from "../components/shared";
import { CheckoutFooter } from "../components/checkout";
import { useTranslation } from "../hooks/useTranslation";
import "../styles/legal/LegalPages.css";

const CookiePolicy = () => {
  const { t } = useTranslation('cookie');
  const sections = t('sections', { returnObjects: true });

  const renderItems = (items) => {
    if (!items) return null;
    return (
      <ul>
        {items.map((item, index) => (
          <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
        ))}
      </ul>
    );
  };

  const renderSubsections = (subsections) => {
    if (!subsections) return null;
    return subsections.map((subsection, index) => (
      <div key={index} className="privacy-subsection">
        {subsection.subtitle && <h3>{subsection.subtitle}</h3>}
        {subsection.content && <p>{subsection.content}</p>}
        {subsection.items && renderItems(subsection.items)}
        {subsection.note && (
          <p className="privacy-note"><em>Note: {subsection.note}</em></p>
        )}
      </div>
    ));
  };

  return (
    <div className="privacy-policy-page">
      <Header />
      <div className="privacy-policy-container">
        <div className="privacy-policy-content">
          <h1 className="privacy-policy-title">{t('page.title')}</h1>
          <p className="privacy-policy-last-updated">
            {t('page.lastUpdated')}: {new Date().toLocaleDateString()}
          </p>

          {sections.map((section, index) => (
            <section key={index} className="privacy-section">
              <h2>{section.title}</h2>
              {section.content && <p>{section.content}</p>}
              {section.items && renderItems(section.items)}
              {section.subsections && renderSubsections(section.subsections)}
              {section.note && (
                <p className="privacy-note"><em>{section.note}</em></p>
              )}
              {section.contact && (
                <div className="contact-info">
                  <p className="contact-info-title">{section.contact.company}</p>
                  <div className="contact-info-grid">
                    <p className="contact-info-item">
                      <span className="label">Email:</span> {section.contact.email}
                    </p>
                    <p className="contact-info-item">
                      <span className="label">Phone:</span> {section.contact.phone}
                    </p>
                    <p className="contact-info-item full-width">
                      <span className="label">Address:</span> {section.contact.address}
                    </p>
                  </div>
                </div>
              )}
            </section>
          ))}

          <div className="policy-disclaimer">
            <p><em>{t('disclaimer')}</em></p>
          </div>
        </div>
      </div>
      <CheckoutFooter />
    </div>
  );
};

export default CookiePolicy;
